import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import Photo from '@blocks/Photo'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import PhotoSlider from '@customer/components/sliders/Photo'
import useSlider from '@hooks/useSlider'
import { colors } from '@styles/vars'
import { ReactComponent as EditIcon } from '@icons/edit.svg'
import React from 'react'
import styled from 'styled-components'
import PastParticipationAward from './components/Award'
import PastParticipationScore from './components/PastParticipationScore'
import PastParticipationStatus from './components/PastParticipationStatus'
import PastParticipationContext from './context'

export default function SalonPastParticipation({ participation }: Props) {
    const { salon, gallery } = useSalonContext()

    const handleChange = (photo: Interfaces.Photo) => {
        gallery.methods.update(photo)
        salon.methods.photo.update(photo)
    }

    const slider = useSlider(PhotoSlider, {
        photo: participation.photo,
        onChange: handleChange
    })

    return (
        <PastParticipationContext.Provider value={{ participation }}>
            <Wrapper style={{ opacity: participation.is_accepted ? 1 : .6 }}>
                <EmphasizedContent 
                    border={participation.is_accepted ? undefined : `1px dashed ${colors.border}`}
                    background={participation.is_accepted ? undefined : "#fff"}
                    narrow>
                    <Grid gap="10px">
                        <Photo data={participation.photo} onClick={slider.open} toolbar={[
                            { icon: <EditIcon />, onClick: slider.open }
                        ]} middle={<PastParticipationScore score={participation.score} />} />
                        <Grid gap="10px">
                            <PastParticipationStatus is_accepted={participation.is_accepted} />
                            <PastParticipationAward award={participation.award} />
                            {participation.tracking && <small style={{ textAlign: "center" }}>Tracking number: <a href="https://track.ukrposhta.ua/tracking_EN.html" target="_blank">{participation.tracking.number}</a></small>}
                        </Grid>
                    </Grid>
                </EmphasizedContent>
            </Wrapper>
        </PastParticipationContext.Provider>
    )
}

// STYLES
const Wrapper = styled.div`
    position: relative;
`

// TYPES
interface Props {
    participation: Customer.Resources.PastParticipation
}